<div class="global-bg">
    <div style="flex: 1;"></div>
    <!-- <app-form class="form"></app-form> -->
    <router-outlet class="form"></router-outlet>
    <div style="flex: 1;"></div>
</div>